import { render, staticRenderFns } from "./BaseCountry.vue?vue&type=template&id=48340233"
import script from "./BaseCountry.vue?vue&type=script&lang=ts"
export * from "./BaseCountry.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports